import React from "react";
import { Typography, Layout, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div>
    <Button
    type="link"
    icon={<ArrowLeftOutlined />}
    onClick={() => navigate("/")}
    style={{
      top: "24px",
      marginLeft:"180px",
      fontSize: "16px",
      fontWeight: 500,
      fontFamily: "Inter, sans-serif",
    }}
  >
    Back
  </Button>
    <Content
      style={{
        margin: "0 auto",
        padding: "40px 24px",
        maxWidth: "900px",
        fontFamily: "Inter, sans-serif",
        borderRadius: "12px",
        height:"85vh"
      }}
    >


        <Typography>
          <Title level={1} style={{ fontSize: "42px", fontWeight: 700 }}>
            Refund Policy
          </Title>

          <Paragraph style={{ fontSize: "16px", color: "#555" }}>
            All payments made on <strong>themedianest.ai</strong> are final. As
            a digital subscription service, we do not offer refunds once a
            payment has been processed.
          </Paragraph>

          <Paragraph style={{ fontSize: "16px", color: "#555" }}>
            If you believe a payment was made in error, please contact us at{" "}
            <a href="mailto:info@smartforum.org">info@smartforum.org</a> and we
            will review your case individually.
          </Paragraph>
        </Typography>
    </Content>
    </div>
  );
};

export default RefundPolicy;
